import React, { useState, useEffect } from 'react'
import { Page, Header } from 'components'
import { useParams } from 'react-router'
import { useExameNecroscopicoService } from 'hooks/useExameNecroscopicoService'
import { Form } from './Form'
import { useStyles } from './ExameNecroscopico.styles'

export const ExameNecroscopico = (props) => {
  const { route } = props
  const exameNecroscopicoService = useExameNecroscopicoService()
  const classes = useStyles()
  const params = useParams()
  const [processando, setProcessando] = useState(false) 
  const [exameNecroscopico, setExameNecroscopico] = useState({})

  useEffect(() => {
    exameNecroscopicoService.listarExameNecroscopicoDadosFormulario(params.id, setExameNecroscopico, setProcessando)
  }, [params.id]) // Dependendo apenas de params.id e excluindo serviço

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <div className={classes.formContainer}>
        <Form className={classes.form} exameNecroscopico={exameNecroscopico} setExameNecroscopico={setExameNecroscopico} />
      </div>
    </Page>
  )
}
